import z from "zod";

export enum TestVariantId {
	Easy = "easy",
	Medium = "medium"
}

export enum Content {
	String = "string",
	FillGap = "fill_gap"
}

export interface StringContent {
	type: Content.String;
	text: string;
}

export interface FillGapContent {
	type: Content.FillGap;
}

export interface AnswerVariant {
	text: string;
}

export type ExerciseContent = Array<StringContent | FillGapContent>;

export interface EasyExercise {
	type: TestVariantId.Easy;
	text: ExerciseContent;
	description?: string;
	variants: AnswerVariant[];
	partId: string;
}

export interface MediumExercise {
	type: TestVariantId.Medium;
	text: ExerciseContent;
	description?: string;
	partId: string;
}

export type UnionOfExersises = EasyExercise | MediumExercise;

export const easyAnswerSchema = z.object({
	type: z.literal(TestVariantId.Easy),
	selectedAnswers: z.array(z.string())
});

export const mediumAnswerSchema = z.object({
	type: z.literal(TestVariantId.Medium),
	textAnswers: z.array(z.string())
});

// Answer structures for each exercise type
export type EasyExerciseAnswer = z.infer<typeof easyAnswerSchema>;

export type MediumExerciseAnswer = z.infer<typeof mediumAnswerSchema>;

export type UnionOfAnswers = EasyExerciseAnswer | MediumExerciseAnswer;

// Solution interface
export interface Solution {
	exerciseId: string;
	userAnswer: string | string[];
}
